import React, { useEffect, useState } from 'react';
import TableRowComponent from './TableRowComponent';
import { useTranslation } from "react-i18next";
import { RowObject } from '../../Types/TableTypes';

interface TableComponentProps {
    creatures: RowObject[],
    setCreatures: (creatures: RowObject[])=>void,
    currentTurn: number,
    editMode: boolean,
}

const TableComponent = (props: TableComponentProps)=>{
    
    const [allExpanded, setAllExpanded] = useState(true);
    const [noneExpanded, setNoneExpanded] = useState(true);
    const { t } = useTranslation();
    
    

    useEffect(()=>{
        setNoneExpanded(true);
        setAllExpanded(true);
        props.creatures.forEach(element=>{
            if (element.encounterStats.expanded){
                setNoneExpanded(false);
            }
            if (!element.encounterStats.expanded){
                setAllExpanded(false);
            }
        })
    }, [props.creatures]);

    function rerenderRow(): void {
        props.setCreatures([...props.creatures]);
    }
    // function updateEncounterStats (encounterStats: EncounterStats, index: number) {
    //     props.creatures[index].encounterStats = encounterStats;
    //     props.setCreatures([...props.creatures]);
    // }

    // function updateCreatureStats (stats:CreatureStats, index: number) {
    //     props.creatures[index].creatureStats = stats;
    //     props.setCreatures([...props.creatures]);
    
    // }

    function deleteRow(index:number){
        props.creatures.splice(index, 1);
        props.setCreatures([...props.creatures]);
    }

    function duplicateRow(index:number){
        props.creatures.splice(index+1, 0, structuredClone(props.creatures[index]))
        props.setCreatures([...props.creatures]);
    }

    function updateIndex(index:number, delta: number){
        if ((index + delta) >= 0 && (index + delta) < props.creatures.length){
            const temp1 = props.creatures[index];
            const temp2 = props.creatures[index+ delta];
            props.creatures[index] = temp2;
            props.creatures[index+ delta] = temp1;
            props.setCreatures([...props.creatures]);
        }
    }
    //console.log("render table");
    return(
        <table className='table'>
            <thead style={{ top: "150px"}}
                // className="header" style={{top: "77px"}}
            >
                <tr>
                    <th scope="col" style={{width: "3%", minWidth: "32px"}}>
                        
                        {allExpanded && <span onClick={e=>{props.creatures.forEach(e=>e.encounterStats.expanded = false); props.setCreatures([...props.creatures])}} role="button" >
                            <i className="bi bi-caret-up-fill"></i>
                        </span>}
                        {noneExpanded && <span onClick={e=>{props.creatures.forEach(e=>e.encounterStats.expanded = true); props.setCreatures([...props.creatures])}} role="button" >
                            <i className="bi bi-caret-down-fill"></i>
                        </span>}
                        {!allExpanded && !noneExpanded && <span onClick={e=>{props.creatures.forEach(e=>e.encounterStats.expanded = false); props.setCreatures([...props.creatures])}} role="button" >
                            <i className="bi bi-caret-right-fill"></i>
                        </span>}
                    </th>
                    <th scope="col" style={{width: "10%", minWidth: "128px"}}>{t("header-initiative")}</th>
                    <th scope="col" style={{width: "25%"}}>{t("header-name")}</th>
                    <th scope="col" style={{width: "15%", minWidth: "210px"}}>{t("header-hp")}</th>
                    <th scope="col" style={{width: "64px"}}></th>
                    <th scope="col" style={{width: "5%", minWidth: "72px"}}>{t("header-ac")}</th>
                    <th scope="col" style={{width: "auto"}}>{t("header-conditions")}</th>
                    <th scope="col" style={{width: "5%", minWidth: "64px"}}>{t("header-reaction")}</th>
                    <th scope="col" style={{width: "2%", minWidth: "32px"}}></th>
                </tr>
                <tr>
                    <td colSpan={9} style={{borderWidth: "0", padding: "0"}}>
                        <div style={{ borderStyle: "solid", borderWidth: "2px"}}></div>
                    </td>
                </tr>
            </thead>
            <tbody className="tablebody">
                {props.creatures.map((row, index)=>{return(
                    <TableRowComponent 
                        key={"row-"+index+"-"+row.id}
                        row={row} 
                        index={index} 
                        isPlayer={row.creatureStats.isPlayer}
                        initiativeBonus={row.creatureStats.initiativeBonus}
                        rerenderRow={rerenderRow} 
                        deleteRow={deleteRow} 
                        duplicateRow={duplicateRow} 
                        updateIndex={updateIndex}
                        isCurrentTurn={props.currentTurn===index}
                        editMode={props.editMode}
                    ></TableRowComponent>
                )})}
            </tbody>
        </table>
    );

}

export default TableComponent;